<template>
    <el-dialog
        class="dialog-container"
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        :before-close="cancel"
        :title="title"
        :width="width"
        center>
        <div class="flex flex-direction padding-sm">
            <slot name="content"></slot>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "SlotContentDialog",
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
        },
        width: {
            type: String,
            default: '600px'
        },
    },
    data() {
        return {}
    },
    created() {
    },
    methods: {
        async submit() {
            this.$emit('watchState', true)
        },
        cancel() {
            this.$emit('watchState', false)
        }
    },
    watch: {

    }
}
</script>

<style scoped lang="scss">
.dialog-container {

}
</style>